// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"303":"3317b786","371":"a53a54e1","681":"97d6b753"}[chunkId] + ".css";
};